import * as React from 'react';
import { memoize } from '@cian/newbuilding-utils';
import { Chips } from '@cian/ui-kit';

import { createDiscountPromoSearchTypeDescriptors } from '../../constants/descriptors';
import { isDescriptorActive, isValid } from '../../utils/filters';
import { connectToDescriptors, IDescriptorProps } from '../сonnectToDescriptors';
import { TTypedThunkDispatch } from '../../types/thunk';
import { getOffersCount } from '../../actions/offersData';

export interface IDiscountPromoSearchTypeProps extends IDescriptorProps<string> {
  getOffersCount(): void;
}

export const DiscountPromoSearchTypeComponent: React.FC<IDiscountPromoSearchTypeProps> = React.memo(
  ({ actionCreator, getOffersCount, jsonQuery, descriptors }) => {
    const options = React.useMemo(
      () =>
        descriptors
          .filter(descriptor => isValid(jsonQuery)(descriptor))
          .map(({ state, label }) => ({
            label,
            value: state,
          })),
      [descriptors, jsonQuery],
    );

    const activeDescriptors = descriptors.filter(descriptor => isDescriptorActive(descriptor)(jsonQuery));
    const currentValues = React.useMemo(() => activeDescriptors.map(d => d.state), [activeDescriptors]);

    const handleChipClick = React.useCallback(
      (value: string) => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        actionCreator(descriptors.find(d => d.state === value)!)();
        getOffersCount();
      },
      [actionCreator, descriptors, getOffersCount],
    );

    return (
      <Chips options={options} size="S" value={currentValues} selectType="multiple" onChipClick={handleChipClick} />
    );
  },
);

DiscountPromoSearchTypeComponent.displayName = 'DiscountPromoSearchTypeComponent';

function mapDispatchToProps(dispatch: TTypedThunkDispatch) {
  return {
    getOffersCount: () => {
      dispatch(getOffersCount());
    },
  };
}

export const DiscountPromoSearchType = connectToDescriptors(
  memoize(createDiscountPromoSearchTypeDescriptors),
  mapDispatchToProps,
)(DiscountPromoSearchTypeComponent);
